import useLogoUrlReplacement from 'components/Dashboard/UserContent/ui/useLogoUrlReplacement';

interface UploadHubLandingPreviewProps {
  organisationLogo: string | null;
  backgroundColour: string;
  barBackgroundColour: string;
}

const UploadHubLandingPreview = (props: UploadHubLandingPreviewProps) => {
  const { organisationLogo, backgroundColour, barBackgroundColour } = props ?? {};
  const { clientLogoReplacement } = useLogoUrlReplacement();
  const logoUrl = organisationLogo?.startsWith('data:')
    ? organisationLogo
    : clientLogoReplacement({ organisationLogo });

  return (
    <div className='rounded border overflow-hidden' style={{ backgroundColor: backgroundColour }}>
      <div className='flex-centered px-1 specific-y-padding-4' style={{ backgroundColor: barBackgroundColour }}>
        {organisationLogo && (
          <img
            src={logoUrl}
            alt='Organisation logo'
            style={{ borderRadius: '3px', width: '15px', height: '16px', objectFit: 'cover' }}
          />
        )}
      </div>
      <div className='p-3'>
        <div className='rounded overflow-hidden'>
          <div className='bg-white flex-centered justify-content-center' style={{ height: '142px' }}>
            <p className='mb-0 main-light-text'>Your file</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadHubLandingPreview;
